import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";
import { Link, useNavigate, useSearchParams, useParams } from "react-router-dom"; 
import { drtsAPIURL } from '../Constant';
import { trackPromise } from 'react-promise-tracker';
import { ToastContainer, toast } from "react-toastify";
import useFetch from "./useFetch";
import OtpApp from '../Otp/App';
import ReCAPTCHA from 'react-google-recaptcha';


//const Signin = () => {
  export default function  Signin(){

  const history = useNavigate(); 
  const [isDRTSLogin, setIsDRTSLogin] = useState(false);
  const [omang, setOmang] = useState(''); 
  const [password, setPassword] = useState('');
  const [togglePassword, setTogglePassword] = useState(false);
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [loginBtnDisabled, setLoginBtnDisabled] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState('');

  const initialValues = { omang: "",password: ""}

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const params = useParams(); //alert("Token 1 is: "+ params.token);

  
  const handleChange = (event) => {

    const { name, value } = event.target;

    if(event.target.name=="omang") setOmang(event.target.value);           
    if(event.target.name=="password") setPassword(event.target.value); 

    setFormValues({ ...formValues, [name]: value });

    let parame=event.target.name;
    if (formErrors[parame]!=undefined&&formErrors[parame]!=null) delete formErrors[parame];
    setFormErrors(formErrors);

  }

   const handleCaptchaChange = (value) => {

        
    
        if(value!=null){ //alert(value);

            setRecaptchaValue(value);

            setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });

            if (formErrors["captchaValue"]!=undefined&&formErrors["captchaValue"]!=null) delete formErrors["captchaValue"];
            setFormErrors(formErrors);

         }
         else {
          //alert('reCaptcha is null');
          if (formValues["captchaValue"]!=undefined&&formValues["captchaValue"]!=null) delete formValues["captchaValue"];
          setFormValues(formValues);
         }
         

    }

  
  const submitHandler = (e) => {

    e.preventDefault();

    //const captchaValue = ReCAPTCHA.current.getValue();
     
    if (!recaptchaValue) {//alert("-----"+recaptchaValue)
    
    }
    else{
      
      setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });
     }
    
    setFormErrors(validate(formValues));

    setIsSubmit(true);

  };

  useEffect(() => {

    if(login){
      history(`${process.env.PUBLIC_URL}/eservices/PaymentsEServices`);      
       }
  
    }, []);

    useEffect(() => {
      
      //setRecaptchaValue(value);
      setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });
      
     }, [recaptchaValue]);

  useEffect(() => {

        if (Object.keys(formErrors).length === 0 && isSubmit) {

            setLoginBtnDisabled(true);

             trackPromise(
              loginRequest(drtsAPIURL+"login")
              ); 
             // toast.success("Sending");

        }
    else{

          if (Object.keys(formErrors).length > 0 && isSubmit) {
            toast.error("Please fill all the required fields. There are errors in your form.");
           }

           }

       }, [formErrors]);


    const validate = (values) => {//alert('validate');

      const errors = {};
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          
    
      if (!values.omang) {
        errors.omang = "You must enter the Omang Number/Passport Number";
      }
    
      if (!values.password) {
        errors.password = "You must enter the password";
      }
    
         
      if (!values.captchaValue ||values.captchaValue==null) {//alert(recaptchaValue);
        errors.captchaValue = "You must confirm that you're human, by clicking on the checkbox.";
      }
    
          
      return errors;
    
    };

 
 
  async function loginRequest(url) {
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          omang: omang,
          password: password,          
        }),
      })
        .then((response) => {

          if (response.ok) {
            //console.log('hh8 -- '+JSON.stringify(respose))
            return response.json()
          }
          else{
            return response.json().then(text => { 
              //throw new Error(text) 
              if(text.message!=undefined){
              toast.error("Request failed: "+text.message);
              }
              else{
                toast.error("Request failed: Could not connect to the server");  
              }
            });
          }
        })
        .then((data) => {
         
          setLoginBtnDisabled(false);
        
          if (data.status!=null&&data.status==true&&data.status!=undefined) {

            localStorage.setItem('user_id_temp', data.user.id);
            
            setIsDRTSLogin(true);
            toast.success(data.message);

          } else {

            setIsDRTSLogin(false);

            if (data.status!=null&&data.status!=undefined) {
              toast.error("Error: "+data.message);
              }
           else{
             toast.error("Ooops! An unexpected error occurred. Try again shortly.");
             }
          }
        })
    } catch (error) {
      setLoginBtnDisabled(false);
      setIsDRTSLogin(false);
      //console.log(JSON.stringify(error));
      toast.error("Oops...An error occurred!");
    }
  }

  const [isMenuHovering, setIsMenuHovering] = useState(false);
 

  return (
    <Fragment>
      <Container fluid={true} className="p-0 login-page">
        
       {isDRTSLogin ? (
        <OtpApp />
         ) :
        (<Row>
          <Col xs="12">
            <div className="login-card" style={{"padding":0, "margin":0}}>

            { /* error && <div>{ error }</div> */ }
            { /*isPending && <div>Loading...</div> */}
            { /* diteng && <BlogList blogs={diteng} /> */ }

              <div className="login-main login-tab">

                <Form className="theme-form"  onSubmit={submitHandler}>

                  <H4><div style={{"color":"#6ec6ec","paddingBottom":"5px"}}>{"LOGIN"}</div></H4>
                  <FormGroup>
                    <Label className="col-form-label">{"Omang/Passport Number: "}</Label>
                    <Input name="omang" className="form-control" type="text" onChange={handleChange} value={omang} />
                    <span style={{ color: 'red' }}>{formErrors.omang}</span>
                  </FormGroup>

                  <FormGroup className="position-relative"> 
                    <Label className="col-form-label">{"Password:"}</Label>
                    <div className="position-relative">
                      <Input name="password" className="form-control" type={togglePassword ? "text" : "password"} onChange={(e) => handleChange(e)} value={password} />
                      <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
                        <span className={togglePassword ? "" : "show"}></span>
                      </div>
                    </div>
                    <span style={{ color: 'red' }}>{formErrors.password}</span>
                  </FormGroup>

        <div className="media-body" style={{width:"100%", textAlign:"right", paddingLeft:230,paddingTop:2,paddingBottom:0,margin:0}}>         
         <ol className='breadcrumb' style={{width:"100%", textAlign:"right", margin:0,paddingBottom:0, paddingTop:0, paddingLeft:5}} >   
            <li className='drts-menu-item' style={{ paddingRight:0,  paddingBottom:0, color:isMenuHovering ? "#000000":'#6ec6ec' }} 
             onMouseEnter={() => setIsMenuHovering(true)}
             onMouseLeave={() => setIsMenuHovering(false)}>
                <Link to={`${process.env.PUBLIC_URL}/eservices/ForgotPassword`}
                   style={{color:isMenuHovering ? "#000000":'#6ec6ec' }}>{ " Forgot Password?"}</Link>
            </li>   
          </ol>   
         </div>
         <Row>
                 <Col> 

                <ReCAPTCHA onChange={(val)=>handleCaptchaChange(val)} sitekey={process.env.REACT_APP_SITE_KEY} />
                <span style={{ color: 'red' }}>{formErrors.captchaValue}</span>

                 </Col>
                </Row>
                  
                  <div className="position-relative form-group mb-0">
                    
                                  <Btn disabled={loginBtnDisabled} attrBtn={{ color: "primary", className: "d-block w-100 mt-2",disabled:loginBtnDisabled }}>{"Login"}</Btn>
                  </div>
                
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      )}
      
      </Container>
      <ToastContainer />
    </Fragment>
  );
}

//export default Signin;
